<template>
  <div v-if="items" class="hero-block">
    <button v-show="items.length > 1" class="hero-block__navigation hero-block__navigation--prev js-prev-slide-hero-carousel">
      <oie-use-svg svg="caret" class="svg--180"></oie-use-svg>
    </button>

    <button v-show="items.length > 1" class="hero-block__navigation hero-block__navigation--next js-next-slide-hero-carousel">
      <oie-use-svg svg="caret"></oie-use-svg>
    </button>

    <div
      v-if="items.length > 1"
      id="hero-carousel"
      v-product-slider="{settings, id: `hero-carousel`}"
      class="hero-block__caruosel-container">
      <oie-hero-item v-for="item of items" :key="item.title" :item="item"></oie-hero-item>
    </div>

    <oie-hero-item
      v-for="item of items"
      v-else
      :key="item.title"
      :item="item"></oie-hero-item>
  </div>
</template>

<script>
export default {
  props: {
    items: { type: Array, required: true, default: null }
  },
  data: () => ({
    settings: {
      container: '#hero-carousel',
      items: 1,
      autoplay: true,
      autoplayTimeout: 5000,
      autoplayHoverPause: true,
      autoplayButton: false,
      swipeAngle: 45,
      controls: false,
      speed: 180,
      navPosition: 'bottom'
    }
  }),
  methods: {
    heroPlacementClass(placement) {
      return `hero-item__container--${placement}`
    }
  }
}
</script>

<style lang="scss">
.hero-block {
  position: relative;
  width: 100%;
}

.hero-block button[data-action] {
  display: none !important;
}

.hero-block__caruosel-container {
  @supports (display: grid) {
    display: flex;
  }
}

.hero-block__navigation {
  display: none;

  @include media(small) {
    position: absolute;
    top: calc(50% - (1.475rem));
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.5rem;
    height: 2.5rem;
    background-color: rgba(51,51,51,1);
    color: white;
    border: none;
    transform: translateY(-50%);
    z-index: 1;

    &:hover {
      cursor: pointer;
    }
  }
}

.hero-block__navigation--prev {
  left: measure(container-distance);
}

.hero-block__navigation--next {
  right: measure(container-distance);
}

.hero-block .tns-nav {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: measure(half);
}

.hero-block .tns-nav > button {
  width: 1.4rem;
  height: 0.45rem;
  margin-left: measure(quarter);
  background-color: color('gray-2');
  border: none;

  @include media(small) {
    width: 1.875rem;
  }
}

.hero-block .tns-nav > button:first-child {
  margin-left: 0;
}

.hero-block .tns-nav .tns-nav-active {
  background-color: color('blue-1');
}
</style>
